import FundDetailsManagers from './FundDetailsManagers'

export default FundDetailsManagers
